// Fixed books list — same for ALL students/batches.
// Keys MUST match what Wix backend stores in BookScores collection.
export const BOOKS = [
  {
    key:         'marie_mysterious_rock',
    title:       "Marie's Mysterious Rock",
    author:      'Marie Curie',
    subtitle:    'Discover the secrets of the fun-filled radioactive world',
    emoji:       '🪨',
    color:       '#ECA529',
    colorDark:   '#B57A10',
    bgGradient:  'linear-gradient(135deg, #F9B23E, #E29B1A)',
  },
  {
    key:         'einstein_wonders',
    title:       "Einstein's Wonders",
    author:      'Albert Einstein',
    subtitle:    'Hop on a journey of wonder and discover power of imagination',
    emoji:       '⚡',
    color:       '#8B5CF6',
    colorDark:   '#6D28D9',
    bgGradient:  'linear-gradient(135deg, #A78BFA, #8B5CF6)',
  },
  {
    key:         'archimedes_explorations',
    title:       "Archimedes' Explorations",
    author:      'Archimedes',
    subtitle:    'A journey through the life and wonders of Archimedes',
    emoji:       '🌊',
    color:       '#22C55E',
    colorDark:   '#15803D',
    bgGradient:  'linear-gradient(135deg, #4ADE80, #22C55E)',
  },
  {
    key:         'tesla_dream',
    title:       "Tesla's Dream",
    author:      'Nikola Tesla',
    subtitle:    'A journey through sparks, science and imagination',
    emoji:       '🔬',
    color:       '#3B82F6',
    colorDark:   '#1D4ED8',
    bgGradient:  'linear-gradient(135deg, #60A5FA, #3B82F6)',
  },
  {
    key:         'eureka_archimedes',
    title:       "'Eureka!' Says Archimedes",
    author:      'Archimedes',
    subtitle:    "Discover Archimedes' knowledge helping his country",
    emoji:       '💡',
    color:       '#A855F7',
    colorDark:   '#7E22CE',
    bgGradient:  'linear-gradient(135deg, #C084FC, #A855F7)',
  },
  {
    key:         'katherine_courage',
    title:       "Katherine's Courage",
    author:      'Katherine Johnson',
    subtitle:    'A journey through the life of Katherine Johnson',
    emoji:       '🚀',
    color:       '#06B6D4',
    colorDark:   '#0369A1',
    bgGradient:  'linear-gradient(135deg, #22D3EE, #06B6D4)',
  },
  {
    key:         'ada_algorithm',
    title:       "Ada's Algorithm",
    author:      'Ada Lovelace',
    subtitle:    'Ada Lovelace\'s life in science and her dream of making machines do the impossible',
    emoji:       '💻',
    color:       '#EAB308',
    colorDark:   '#A16207',
    bgGradient:  'linear-gradient(135deg, #FDE047, #EAB308)',
  },
  {
    key:         'vikram_victory',
    title:       "Vikram's Victory",
    author:      'Vikram Sarabhai',
    subtitle:    'Join Vikram Sarabhai and discover the power of exploration',
    emoji:       '🛸',
    color:       '#EF4444',
    colorDark:   '#B91C1C',
    bgGradient:  'linear-gradient(135deg, #F87171, #EF4444)',
  },
  {
    key:         'einstein_global_citizen',
    title:       "Einstein: The Global Citizen",
    author:      'Albert Einstein',
    subtitle:    'A journey through the life and discoveries of Albert Einstein',
    emoji:       '🌍',
    color:       '#16A34A',
    colorDark:   '#15803D',
    bgGradient:  'linear-gradient(135deg, #4ADE80, #16A34A)',
  },
  {
    key:         'rosalind_secret_shot',
    title:       "Rosalind & the Secret Shot",
    author:      'Rosalind Franklin',
    subtitle:    'Revealing the life and discoveries of Rosalind Franklin',
    emoji:       '🧬',
    color:       '#EC4899',
    colorDark:   '#BE185D',
    bgGradient:  'linear-gradient(135deg, #F472B6, #EC4899)',
  },
  {
    key:         'marie_legacy_lives_on',
    title:       "Marie's Legacy Lives On",
    author:      'Marie Curie',
    subtitle:    'Discover the secrets of the fun-filled radioactive world',
    emoji:       '⚗️',
    color:       '#84CC16',
    colorDark:   '#4D7C0F',
    bgGradient:  'linear-gradient(135deg, #A3E635, #84CC16)',
  }
];
